import Select, { ActionMeta, StylesConfig } from 'react-select';
import { AbstractSelectElement, SelectOption } from '@app/common';
import RequiredAsterisk from '../RequiredAsterisk';

type Properties = {
    data: AbstractSelectElement;
    value?: any;
    setValue: (value: any) => void;
};

const multiselectStyles: StylesConfig = {
    control: (provided) => ({
        ...provided,
        border: '.1em solid var(--color-gray-600)',
        borderRadius: '.3em',
        fontSize: '1.1em',
        fontWeight: 700,
        color: 'black',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'black',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'black',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '.2em .5em',
    }),
    input: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
    }), 
};

const InputSelect = (props: Properties) => {
    const { value, setValue } = props;
    let emptyOption = null;
    if (value === undefined) {
        emptyOption = <option value="no-value" disabled={true}>Bitte wählen</option>;
    }

    const label = props.data.label || '';
    const labelEl = <label>{label}<RequiredAsterisk required={props.data.required} /></label>;

    const onMultiselectChange = (option: readonly SelectOption[], actionMeta: ActionMeta<SelectOption>) => {
        // const values = option.map(opt => opt.value);
        setValue(option);
    };

    // const multiselectValue = (value as string[])?.map(option => props.data.options.find(o => o.value === option));

    if (props.data.multiselect) {
        return (
            <fieldset>
                {labelEl}
                <Select
                    styles={multiselectStyles}
                    options={props.data.options}
                    isMulti={true}
                    value={value}
                    onChange={onMultiselectChange}
                    placeholder="Bitte wählen"
                    isClearable={false}
                    isSearchable={false}
                />
            </fieldset>
        );
    }

    const options = props.data.options.map(option => 
        <option 
            key={option.value} 
            value={option.value}
        >
            {option.label}
        </option>
    );

    return (
        <fieldset className="page-input page-input-select">
            {labelEl}
            <select
                onChange={ev => setValue(ev.target.value)}
                value={value || 'no-value'}
            >
                {emptyOption}
                {options}
                <optgroup label="" />
            </select>
        </fieldset>
    );
};
export default InputSelect;